import { render } from "./tv-selector.vue?vue&type=template&id=0f10ab5a&scoped=true&ts=true"
import script from "./tv-selector.vue?vue&type=script&lang=ts"
export * from "./tv-selector.vue?vue&type=script&lang=ts"

import "./tv-selector.vue?vue&type=style&index=0&id=0f10ab5a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f10ab5a"]])

export default __exports__